import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { SessionStorageService } from '@core/services';
import { SessionStorageType } from '@core/enums';

export const authInterceptor: HttpInterceptorFn = (request, next) => {
  const sessionStorageService = inject(SessionStorageService);
  const token: string | null = sessionStorageService.getItemParsed(SessionStorageType.TOKEN);

  const secureEndpoints = ['/dynamic/applications'];
  const isSecure = secureEndpoints.some(endpoint => request.url.includes(endpoint));

  if (token && isSecure) {
    const cloned = request.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
    });
    return next(cloned);
  }

  return next(request);
};
